import { CertificateEnabledDto } from '@/application/interfaces/classroom/pegasus.gateway';
import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';

const collaborationName = 'GetClassroomByTopic';

export const ObtainedCertificateEnabledIdentifier = 'ObtainedCertificateEnabled';
export class ObtainedCertificateEnabled extends CollaborationResult<CertificateEnabledDto> {
  constructor(data: CertificateEnabledDto | undefined) {
    super(
      collaborationName,
      ObtainedCertificateEnabledIdentifier,
      'Certificate enable validation successfully obtained',
      data,
    );
  }
}

export const CertificateCourseNotFoundIdentifier = 'CertificateCourseNotFound';
export class CertificateCourseNotFound extends CollaborationResult<undefined> {
  constructor() {
    super(collaborationName, CertificateCourseNotFoundIdentifier, 'course not found');
  }
}

export const CertificateEnabledUnexpectedErrorIdentifier = 'UnexpectedError';
export class CertificateEnabledUnexpectedError extends CollaborationResult<undefined> {
  constructor() {
    super(
      collaborationName,
      CertificateEnabledUnexpectedErrorIdentifier,
      'An unexpected error occurs',
    );
  }
}
